import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	filterMenuWrapper: {
		display: 'flex',
		justifyContent: 'center',
		flexWrap: 'wrap',
		gap: theme.spacing.medium,

		[getFromBreakpoint('md')]: {
			gap: theme.spacing.small,
		},
	},
	filterMenu: {
		display: 'grid',
		gap: theme.spacing.small,
		gridTemplateRows: '1fr',
		gridTemplateColumns: '1fr',
		padding: 0,
		width: '100%',

		[getFromBreakpoint('md')]: {
			gridTemplateRows: 'auto',
			gridTemplateColumns: 'repeat(auto-fit, minmax(130px, auto))',
			justifyContent: 'center',
		},
	},
	tag: {
		display: 'grid',
		minWidth: theme.spacing.small,
		gridTemplateRows: 'auto',
		gridTemplateColumns: 'auto 0fr',
		marginRight: theme.spacing.xxsmall,

		'& > span': {
			whiteSpace: 'nowrap',
		},
	},
	days: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	dropdown: {
		'& > div:nth-of-type(2)': {
			padding: 0,
			width: '300px',
		},
	},
	filterOptions: {
		display: 'flex',
		flexDirection: 'row',
		gap: theme.spacing.small,
		width: '100%',

		[getFromBreakpoint('md')]: {
			alignItems: 'center',
			justifyContent: 'center',
			width: '100%',
		},
	},
}));
